"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _de = _interopRequireDefault(require("../locales-js/de"));

var _el = _interopRequireDefault(require("../locales-js/el"));

var _en = _interopRequireDefault(require("../locales-js/en"));

var _es = _interopRequireDefault(require("../locales-js/es"));

var _fr = _interopRequireDefault(require("../locales-js/fr"));

var _it = _interopRequireDefault(require("../locales-js/it"));

var _ja = _interopRequireDefault(require("../locales-js/ja"));

var _nl = _interopRequireDefault(require("../locales-js/nl"));

var _pl = _interopRequireDefault(require("../locales-js/pl"));

var _pt = _interopRequireDefault(require("../locales-js/pt"));

var _ro = _interopRequireDefault(require("../locales-js/ro"));

var _ru = _interopRequireDefault(require("../locales-js/ru"));

var _uk = _interopRequireDefault(require("../locales-js/uk"));

var _zh = _interopRequireDefault(require("../locales-js/zh"));

var locales = {
  de: _de["default"].de,
  el: _el["default"].el,
  en: _en["default"].en,
  es: _es["default"].es,
  fr: _fr["default"].fr,
  it: _it["default"].it,
  ja: _ja["default"].ja,
  nl: _nl["default"].nl,
  pl: _pl["default"].pl,
  pt: _pt["default"].pt,
  ro: _ro["default"].ro,
  ru: _ru["default"].ru,
  uk: _uk["default"].uk,
  zh: _zh["default"].zh
};
var _default = locales;
exports["default"] = _default;
//# sourceMappingURL=index.js.map